import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const BUYERS = [{
  name: 'Carlos Ramírez',
  city: 'Ciudad de México'
}, {
  name: 'Fernanda López',
  city: 'Bogotá'
}, {
  name: 'Miguel Hernández',
  city: 'Buenos Aires'
}, {
  name: 'Valeria Torres',
  city: 'Lima'
}, {
  name: 'Diego Morales',
  city: 'Santiago'
}, {
  name: 'Sofía Mendoza',
  city: 'Monterrey'
}, {
  name: 'Andrés Gutiérrez',
  city: 'Medellín'
}, {
  name: 'Paola Sánchez',
  city: 'Guadalajara'
}, {
  name: 'Rodrigo Flores',
  city: 'Caracas'
}, {
  name: 'Daniela Reyes',
  city: 'Quito'
}, {
  name: 'Sebastián Castro',
  city: 'Montevideo'
}, {
  name: 'Camila Vargas',
  city: 'Asunción'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(BUYERS[0]);
  useEffect(() => {
    // Initial delay of 5 seconds
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showPopup = () => {
    // Select random buyer
    const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
    setCurrentBuyer(randomBuyer);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup (random between 15-30 seconds)
      const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
      setTimeout(showPopup, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-32">
      {isVisible && <motion.div initial={{
      y: 50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 50,
      opacity: 0
    }} transition={{
      duration: 0.5
    }} className="fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 max-w-sm flex items-start gap-3" data-id="element-33">
          <div className="flex-shrink-0 mt-1" data-id="element-34">
            <CheckCircle className="w-6 h-6 text-green-500" data-id="element-35" />
          </div>
          <div data-id="element-36">
            <p className="text-gray-900 text-sm" data-id="element-37">
              <span className="font-bold" data-id="element-38">{currentBuyer.name}</span> acaba de
              comprar desde{' '}
              <span className="font-semibold" data-id="element-39">{currentBuyer.city}</span>
            </p>
            <p className="text-gray-500 text-xs mt-1" data-id="element-40">Hace unos segundos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}